export const firstStep = 0;
export const secondStep = 1;
export const thirdStep = 2;

export const PILLARS_AMOUNT = 4;

export const usercenterUser = 3;

export const STATIC_BLUEPRINT = 6;
export const SPEKTRA_BLUEPRINT = 7;

export const SALES_ENGINEER = "Sales Engineer LEX";
export const TECHNICAL_OVERLAY = "Technical Overlay";
export const MIS_AUTOMATION2 = "MIS auto";
export const JEFF_USER = "Jeffington The Wonderboy Bearington Bear Majesty XII";
export const MIS_AUTOMATION4 = "mis auto 4";

export const OPPORTUNITIES_TAB = 0;
export const ACCOUNTS_TAB = 1;
export const NEW_TECHNICAL_ENGAGEMENT_TAB = 0;
export const EXISTING_TECHNICAL_ENGAGEMENT_TAB = 1;

export const CLOUD_TYPES = {
    CLOUDSHARE: 'CLOUDSHARE',
    GOOGLE: 'GOOGLE',
    STATIC: 'STATIC',
    SPEKTRA: 'SPEKTRA',
};

export const MAX_ENVS_PER_PARTNER_PER_DAY = 2;


